import React, { Component } from 'react'
import { array } from 'prop-types'
import intl from 'react-intl-universal'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'

import { Input, SVGIcon } from 'components/qstrap'

import { partition } from 'lodash'
import memoize from 'memoize-one'

import FacultiesList from './FacultiesList'

class SchoolFaculties extends Component {
  state = {
    searchKeyword: '',
  }

  searchResults = memoize(
    (faculties, keyword) => {
      if (keyword) {
        const alteredKeyword = keyword.trim().toLowerCase()
        return partition(faculties, faculty =>
          faculty.name.toLowerCase().match(alteredKeyword) ||
          faculty.static_majors.find(major => major.toLowerCase().match(alteredKeyword)) ||
          faculty.study_fields.find(studyField => studyField.toLowerCase().match(alteredKeyword))
        )
      }
      return faculties
    }
  )

  handleSearch = (val) => {
    this.setState({
      searchKeyword: val,
    })
  }

  handleClearSearch = () => {
    this.setState({
      searchKeyword: '',
    })
  }

  render() {
    const { searchKeyword } = this.state
    const { faculties } = this.props
    const icon = searchKeyword ? 'close' : 'search'
    const searchResults = this.searchResults(faculties, searchKeyword)

    return (
      <div className="school-faculties" id="faculties">
        <SectionContainer
          paddingTop={80}
          paddingBottom={120}
          backgroundColor="#f6f7fa"
        >
          <Container>
            <SectionTitle title="Fakultas dan Jurusan" />
            <div className="school-faculties__search">
              <div className="school-faculties__search-form">
                <Input
                  type="search"
                  placeholder="Contoh: Kedokteran"
                  onChange={e => this.handleSearch(e.target.value)}
                  value={searchKeyword}
                />
                <div className="school-faculties__search-feedback" onClick={this.handleClearSearch}>
                  <SVGIcon name={icon} />
                </div>
              </div>
            </div>
            <div className="school-faculties__list-container">
              {
                searchKeyword ?
                  <>
                    <FacultiesList faculties={searchResults[0]} />
                    {
                      searchResults[1].length > 0 &&
                      <div className="school-faculties__others">
                        <Typography component="h6" variant="headline">
                          {intl.get('school_faculties.other_faculties')}
                        </Typography>
                        <hr/>
                        <FacultiesList faculties={searchResults[1]} />
                      </div>
                    }
                  </> :
                  <FacultiesList faculties={searchResults} />
              }
            </div>
          </Container>
        </SectionContainer>
        <style jsx>
          {`
            .school-faculties {
              &__search {
                margin: 1em 0;
              }
              &__search-form {
                position: relative;
                max-width: 305px;
                :global(input) {
                  padding-left: 48px;
                  height: 48px;
                  border: solid 1px #bed2e8;
                }
              }
              &__search-feedback {
                position: absolute;
                left: 0;
                top: 0;
                height: 48px;
                width: 48px;
                padding: 14px;
                color: #a3b4ca;
                :global(svg) {
                  fill: #0fc3c4;
                }
              }
              &__others {
                margin: 1.5em 0;
              }
            }
          `}
        </style>
      </div>
    )
  }
}

SchoolFaculties.propTypes = {
  faculties: array,
}

export default SchoolFaculties
